import React from 'react';
import cn from 'classnames';
import { sendEvent } from 'shared/helpers/requests';
import styles from './ThirdBlock.module.scss';
import { ReactComponent as StartIcon } from '../../images/start_icon.svg';
import { ReactComponent as StartIconMobile } from '../../images/start_icon_mobile.svg';
import { ReactComponent as WaveIcon } from '../../images/wave_green.svg';
import { ReactComponent as PriceWrapper } from '../../images/price_third_wrapper.svg';
import { ReactComponent as Background } from '../../images/third_block_bg.svg';
import { ReactComponent as CheckIcon } from '../../images/check.svg';
import { BuyButton } from '../BuyButton';
import { Card } from '../Card';
import { CardType, DEFAULT_CARDS, PRICE } from '../../constants';

type Props = {
  isAfterBuy: boolean;
  goToPayment(): void;
};
export function ThirdBlock({ isAfterBuy, goToPayment }: Props) {
  const handleClickBuy = () => {
    sendEvent({
      eventType: 'click_buy',
      eventSource: 'pryamyye_efiry_kak_kopit',
      eventInfo: JSON.stringify({ place: 'middle' }),
    });
    goToPayment();
  };

  const handleClickCard = () => {
    sendEvent({
      eventType: 'click_buy',
      eventSource: 'pryamyye_efiry_kak_kopit',
      eventInfo: JSON.stringify({ place: 'card' }),
    });
    goToPayment();
  };

  return (
    <div className={styles.root}>
      <WaveIcon className={styles.waveImg} />
      <WaveIcon className={styles.waveImg} />
      <Background className={styles.background} />
      <div className={styles.discount}>
        <div>{PRICE.discount}</div>
        <div>{PRICE.basePrice}&nbsp;₽</div>
      </div>
      <div className={styles.content}>
        <div className={styles.startWrapper}>
          <StartIcon className={styles.startIcon} />
          <StartIconMobile className={cn(styles.startIcon, styles.startIcon_mobile)} />
          <h4>
            Новый эфир <br className={styles.br} />
            каждую неделю!
          </h4>
        </div>
        <h2 className={styles.title}>Ближайшие прямые эфиры</h2>
        <p className={styles.description}>
          Оплата дает доступ к&nbsp;40&nbsp;будущим эфирам и&nbsp;материалам к&nbsp;ним
        </p>
        <div className={cn(styles.cardsWrapper)}>
          {DEFAULT_CARDS.map((card, idx) => (
            <Card
              key={card.title}
              {...(card as CardType)}
              color={card.color}
              bgColor={card.bgColor}
              isFirstCard={idx === 0}
              isAfterBuy={isAfterBuy}
              onButtonClick={handleClickCard}
            />
          ))}
        </div>
        <div className={styles.priceWrapper}>
          <div className={styles.priceBlock}>
            <h4 className={styles.priceTitle}>
              {PRICE.priceForLesson}&nbsp;₽&nbsp; за&nbsp;один эфир
            </h4>
            <span className={styles.titleHighlight} />
            <p className={styles.priceDescription}>
              Каждый месяц&nbsp;&mdash; не&nbsp;менее&nbsp; 4&nbsp;эфиров! <br /> Также доступ
              к&nbsp;записям и&nbsp;дополнительным материалам
            </p>
            <span className={styles.descriptionHighlight} />
          </div>
          <div className={styles.buttonWrapper}>
            {isAfterBuy ? (
              <p className={styles.afterBuyText}>
                Доступ оформлен <CheckIcon />
              </p>
            ) : (
              <BuyButton onClick={handleClickBuy} />
            )}
            <div className={styles.buttonPriceWrapper}>
              <PriceWrapper />
              <p className={styles.buttonPrice}>
                <span>{PRICE.price}&nbsp;₽&nbsp;</span>на&nbsp;40&nbsp;эфиров
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
